module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) { fox.registerWidget('SitePage_Login', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/login.js
// module id = 1278
// module chunks = 4